"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BackupSelectorDialog;
var _CloseRounded = _interopRequireDefault(require("@mui/icons-material/esm/CloseRounded.js"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog/Dialog.js"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent/DialogContent.js"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle/DialogTitle.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions/DialogActions.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress/CircularProgress.js"));
var _BackupSelect = _interopRequireDefault(require("./BackupSelect"));
var _BackupDialogContent = _interopRequireDefault(require("./BackupDialogContent"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const itemsReducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case 'SCH':
      return {
        ...state,
        schedules: payload,
        loader: false
      };
    case 'SELSCH':
      return {
        ...state,
        selectedSchedule: payload
      };
    case 'SELSCHLIST':
      return {
        ...state,
        selectedScheduleList: payload
      };
    case 'SELSCHITEM':
      return {
        ...state,
        selectedScheduleItem: payload
      };
    case 'LOADER':
      return {
        ...state,
        loader: payload
      };
    default:
      return state;
  }
};
function BackupSelectorDialog({
  openModal,
  handleClick,
  onClickInitialize,
  getBackupSchedulesService,
  getBackupSchedulesByIdService
}) {
  const [state, dispatch] = (0, _react.useReducer)(itemsReducer, {
    schedules: [],
    selectedSchedule: '',
    selectedScheduleList: [],
    selectedScheduleItem: '',
    loader: false
  });
  const {
    schedules,
    selectedSchedule,
    selectedScheduleList,
    selectedScheduleItem,
    loader
  } = state;
  (0, _react.useEffect)(() => {
    if (openModal) {
      callSchedulesAPI();
    }
  }, [openModal]);
  const callSchedulesAPI = async () => {
    dispatch({
      type: 'LOADER',
      payload: true
    });
    let response = await getBackupSchedulesService();
    dispatch({
      type: 'SCH',
      payload: response
    });
  };
  const onClickSelect = async Id => {
    let selected_sch = schedules.find(item => item.Id === Id);
    dispatch({
      type: 'SELSCH',
      payload: selected_sch
    });
    const data = {
      backupId: Id,
      loadDetails: true
    };
    let response = await getBackupSchedulesByIdService(data);
    dispatch({
      type: 'SELSCHLIST',
      payload: response
    });
  };
  const onClickList = Id => {
    dispatch({
      type: 'SELSCHITEM',
      payload: Id
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog.default, {
      open: openModal,
      onClose: handleClick,
      fullWidth: true,
      maxWidth: "md",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_DialogTitle.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "h5",
          children: "Backups"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
          "aria-label": "close",
          onClick: handleClick,
          sx: {
            color: 'inherit',
            position: 'absolute',
            right: 8,
            top: 8
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CloseRounded.default, {})
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.default, {
        dividers: true,
        children: loader ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "300px",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CircularProgress.default, {})
        }) : schedules?.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_BackupSelect.default, {
            schedules: schedules,
            selectedSchedule: selectedSchedule,
            onClickSelect: onClickSelect
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BackupDialogContent.default, {
            selectedScheduleList: selectedScheduleList,
            selectedSchedule: selectedSchedule,
            onClickList: onClickList,
            selectedScheduleItem: selectedScheduleItem
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "h6",
          children: "No Backup Schedules exist for this app."
        })
      }), schedules?.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogActions.default, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          sx: {
            p: 1
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            variant: "contained",
            disabled: selectedScheduleItem ? false : true,
            onClick: () => onClickInitialize(state),
            children: "Initialize"
          })
        })
      }) : '']
    })
  });
}